<template>
  <div class="info flex">
<!--    <div class="pic"><img :src="head_img"></div>-->
    <div class="text">
      <div class="t-c flex align-items">
        <span class="name">{{hoursTip}}，{{name}}</span>
<!--        <span class="tag tag1">{{occupation_name}}</span>-->
<!--        <span class="tag tag2">购物</span>-->
      </div>
      <div class="b-c">
<!--        <span>手机号码：{{phone}}</span>-->
        <span>达人标签：{{label}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EnterpriseManageInfo',
  data () {
    return {
      hoursTip: ''
    }
  },
  props: {
    name: String,
    money: String,
    phone: String,
    label: String,
    head_img: String,
    occupation_name: String
  },
  methods: {
    getMycount () {
      let self=this;
      let date=new Date();
      if(date.getHours()>=0&&date.getHours()<12){

        self.hoursTip="上午好"

      }else if(date.getHours()>=12&&date.getHours()<18){

        self.hoursTip="下午好"

      }else{

        self.hoursTip="晚上好"

      }
    }
  },
  created () {
    this.getMycount()
  }
}
</script>
<style scoped>
  .info .pic img{width: 80px;height: 80px;border-radius: 50%;border:1px #eee solid;}
  .info .text .t-c{margin-top: 5px;}
  .info .text .t-c .name{font-size:24px;margin-right:10px;}
  .info .text .t-c .tag{padding:0 15px;margin-left:10px;height: 24px;line-height: 24px;border:1px #eee solid;border-radius:5px;}
  .info .text .t-c .tag1{background: #f0f9eb;border:1px #e1f3d8 solid;color:#67c23a;}
  .info .text .t-c .tag2{background: #fdf6ec;border:1px #faecd8 solid;color: #e6a23c;}
  .info .text .b-c{margin-top:15px;}
  .info .text .b-c span{margin-right: 10px;}
</style>
